module.exports = __webpack_public_path__ + "img/montecarlo.3fde909e.svg";